//Photocapture Camera Mirror Enum
//Pass this as the second parameter in photoCapture.capture in order to set mirroring
export const CameraMirroredMode =
	{
		NONE: 0, //No mirroring
		ENVIRONMENT: 1, //Flips the video feed to match the AR, like what the user sees
		AR: 2 //Flips the AR feed to match the video, like what the camera actually sees
	};